import { QuoteRepository } from '../repository';
import { CreateQuoteBody } from '../types/quote';
import { assertString } from '../utils/assertString';
import { assertNumber } from '../utils/assertNumber';
import { Quote } from '../classes/quote';

export class QuoteService {
  constructor(private quoteRepository: QuoteRepository) {}

  async createQuote(args: CreateQuoteBody) {
    assertString(args.coverageStartDate, 'coverageStartDate');
    assertString(args.coverageEndDate, 'coverageEndDate');
    if (args.coverageStartHourNumber !== undefined) {
      assertNumber(args.coverageStartHourNumber, 'coverageStartHourNumber');
    }
    if (args.coverageEndHourNumber !== undefined) {
      assertNumber(args.coverageEndHourNumber, 'coverageEndHourNumber');
    }
    assertString(args.currency, 'currency');
    assertString(args.exposureName, 'exposureName');
    assertNumber(args.exposureLatitude, 'exposureLatitude');
    assertNumber(args.exposureLongitude, 'exposureLongitude');
    assertNumber(
      args.exposureTotalCoverageAmount,
      'exposureTotalCoverageAmount'
    );
    if (args.langLocale !== undefined) {
      assertString(args.langLocale, 'langLocale');
    }

    const quoteData = await this.quoteRepository.create(args);
    return new Quote(quoteData);
  }
}
